export default "__VITE_ASSET__D90MG0fv__"